<script>
import dateMixin from '../../mixins/dateMixin';
import XmlChannelStatusCardHeader from './XmlChannelStatusCardHeader';

export default {
  name: 'XmlChannelStatusCvCard',
  components: {
    XmlChannelStatusCardHeader,
  },
  mixins: [
    dateMixin,
  ],
  props: {
    xmlChannel: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openJobList(xmlChannel) {
      this.$emit('open-job-list', xmlChannel);
    },
  },
};
</script>

<template>
  <v-flex v-if="xmlChannel.latestJob">
    <xml-channel-status-card-header :xml-channel="xmlChannel"/>
    <v-card-text class="pt-0 pb-1 mt-2">
      <span>
        <strong>{{ $t('xmlChannelStatus.xmlChannelStatusCard.receivedUpdates') }}:</strong>
      </span>
      <span>
        {{ xmlChannel.latestJob.updates }}
      </span>
    </v-card-text>
    <v-card-text class="py-0">
      <b>Import:</b>
    </v-card-text>
    <v-card-text class="pt-0 pb-1 pl-4">
      <span>
        Started:
      </span>
      <span>{{ formatDate(xmlChannel.latestJob.messageStart) }}</span>
    </v-card-text>
    <v-card-text class="pt-0 pb-1 pl-4">
      <span>
        Finished:
      </span>
      <span>{{ formatDate(xmlChannel.latestJob.updateStart) }}</span>
    </v-card-text>
    <v-card-text class="py-0">
      <b>Synchronization:</b>
      <span class="grey--text caption">(Not Applicable)</span>
    </v-card-text>
    <v-card-text class="pt-0 pb-1 pl-4">
      <span>
        Started:
      </span>
      <span class="pl-2">-</span>
    </v-card-text>
    <v-card-text class="pt-0 pb-1 pl-4">
      <span>
        Finished:
      </span>
      <span class="pl-2">-</span>
    </v-card-text>
    <v-divider class="mx-2 pt-1"></v-divider>
    <v-btn @click="openJobList(xmlChannel)" color="primary" disabled outline small>
      {{ $t('xmlChannelStatus.xmlChannelStatusCard.productList') }}
    </v-btn>
  </v-flex>
  <v-flex v-else>
    <v-card-title dark>
      {{ xmlChannel.webservice }}
      <v-spacer />
      <small>{{ xmlChannel.system }}</small>
      <v-spacer />
      <badge :badge="badges['NO_CONTENT']"/>
    </v-card-title>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/components/xmlChannelStatus/XmlChannelStatusCVCard.vue